import { render, staticRenderFns } from "./administrationLandingPageCreatorEdit.vue?vue&type=template&id=70fc7877&scoped=true&"
import script from "./administrationLandingPageCreatorEdit.vue?vue&type=script&lang=js&"
export * from "./administrationLandingPageCreatorEdit.vue?vue&type=script&lang=js&"
import style0 from "./administrationLandingPageCreatorEdit.vue?vue&type=style&index=0&id=70fc7877&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc7877",
  null
  
)

export default component.exports